// extracted by mini-css-extract-plugin
export default {"checkbox-wrapper":"checkbox-wrapper---UAXxa","checkbox-with-asterisk":"checkbox-with-asterisk---Wd01Y"};